import { Controller } from "@hotwired/stimulus"

// Click-driven navigation: the desktop mega-menus open on click (one at a time)
// and the mobile panel toggles. Both close on an outside click or Escape.
export default class extends Controller {
  static targets = ["panel", "menu"]

  // Mobile panel
  toggle() {
    this.panelTarget.classList.toggle("hidden")
  }

  // Desktop mega-menu: open the clicked category, closing any other that's open.
  open(event) {
    const menu = event.currentTarget.closest("[data-nav-target='menu']")
    const wasOpen = menu.dataset.open === "true"
    this.closeAll()
    if (!wasOpen) menu.dataset.open = "true"
  }

  closeAll() {
    this.menuTargets.forEach((menu) => (menu.dataset.open = "false"))
    if (this.hasPanelTarget) this.panelTarget.classList.add("hidden")
  }

  closeOnOutside(event) {
    if (!this.element.contains(event.target)) this.closeAll()
  }
}
